import React from "react";
import Header from "component/HeaderBackoffice/HeaderBackoffice";
import { Button, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const BackOfficeLogueado = () => {
  const logeado = sessionStorage.getItem("logeado");
  const rol = localStorage.getItem("rol");
  const navegate = useNavigate();
  function swalWarning() {
    swal
      .fire({
        title: "Credenciales inválidas",
        text: "Por favor ingresar usuario y contraseña correctos",
        icon: "warning",
        confirmButtonColor: "#009bdb",
        confirmButtonText: "Volver",
        
      })
      .then((result) => {
        navegate("/");
        localStorage.clear();
        sessionStorage.clear();
      });
  }
  const button = (
    <Link to="/backoffice" style={{ textDecoration: "none" }}>
      <Button
        style={{ backgroundColor: "#FF3E00", color: "white" }}
        onClick={() => {
          localStorage.clear();
          sessionStorage.clear();
        }}
        variant="contained"
      >
        <Typography
          style={{
            fontSize: "16pt",
            textTransform: "none",
            fontFamily: "Roboto",
            fontWeight: "bold",
          }}
        >
          Salir
        </Typography>
      </Button>
    </Link>
  );
  const welcome = <Typography variant="p">Bienvenido!</Typography>;
  const backoffice = <Typography variant="p"></Typography>;
  return (
    <>
      {rol === "ROLE_EMPRESA" ? (
        swalWarning()
      ) : (
        <Container fixed>
          <div>
            <Header welcome={welcome} button={button} backoffice={backoffice} />

            {logeado === "true" ? (
              <div>
                {rol === "ROLE_VACIADERO" && (
                  <Grid
                    container
                    sx={{ width: "100%" }}
                    style={{
                      marginTop: "2%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Grid size={{ xs: 6 }}>
                      <Link
                        to="/backoffice/vaciadero"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          style={{
                            backgroundColor: "#0055a6",
                            color: "white",
                            alignSelf: "center",
                            width: "100%",
                            padding: "6px 0",
                          }}
                          className="button_responsive"
                          variant="contained"
                        >
                          Consumir Vales
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                )}
                <br />
                {rol === "ROLE_ADMIN" && (
                  <Grid
                    container
                    sx={{ width: "100%" }}
                    style={{
                      marginTop: "2%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Grid size={{ xs: 6 }}>
                      <Link
                        to="/backoffice/reporte"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          style={{
                            backgroundColor: "#0055a6",
                            color: "white",
                            alignSelf: "center",
                            width: "100%",
                            padding: "6px 0",
                          }}
                          className="button_responsive"
                          variant="contained"
                        >
                          Reportes
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                )}
                <br />
              </div>
            ) : (
              <div style={{ marginLeft: "10%", marginTop: "4%" }}>
                <h2>Por favor iniciar la sesión .</h2>
              </div>
            )}
          </div>
        </Container>
      )}
    </>
  );
};

export default BackOfficeLogueado;
